<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="mod-sys__role">
      <el-form label-position="top"
               :inline="true"
               :model="dataForm">
        <el-row class="margb10">
          <!-- 角色名称 -->
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('role.roleName')">
              <el-input v-model="dataForm.roleName"
                        :placeholder="$t('role.roleName')"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5"
                  class="padt5">
            <!-- 角色分类 -->
            <el-form-item :label="$t('role.authType')">
              <el-select v-model="dataForm.roleType"
                         filterable
                         clearable
                         :placeholder="$t('role.authType')"
                         @change="roleTypeChange">
                <el-option v-for="(item,index) in roleType"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 组织类型 -->
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('organization.orgType')"
                          prop="orgType">
              <el-select v-model="dataForm.orgType"
                         :placeholder="$t('organization.orgType')"
                         clearable
                         @change="orgTypeChange">
                <el-option v-for="(item,index) in roleOrgType"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5"
                  class="padt5">
            <!-- 权限分类 -->
            <el-form-item :label="$t('user.permissionclassification')"
                          prop="authType">
              <el-select v-model="dataForm.authType"
                         filterable
                         clearable
                         :placeholder="$t('user.select')"
                         @change="changeAuthType">
                <el-option v-for="(item,index) in authTypeArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         @click="query()">{{$t('query')}}</el-button>
            </el-col>
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         @click="resetModify()">{{ $t('reset') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <div v-show="isShow">
          <el-row class="margb10">
            <el-col :span="5"
                    class="padt5">
              <!-- 数据范围分类 -->
              <el-form-item :label="$t('role.roleOrgScope')">
                <el-select v-model="dataForm.roleOrgScope"
                           filterable
                           clearable
                           :placeholder="$t('role.roleOrgScope')"
                           title="">
                  <el-option v-for="(item,index) in roleOrgScope"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- * 是否内置岗位 -->
            <el-col :span="5"
                    class="padt5">
              <el-form-item :label="$t('role.defaultFlag')"
                            prop="defaultFlag">
                <el-select v-model="dataForm.defaultFlag"
                           clearable
                           :placeholder="$t('role.defaultFlag')">
                  <el-option v-for="(item,index) in confirmStateArr"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <ToggleDiv @toggle="toggle"></ToggleDiv>
      <div class="btn-left">
        <el-button type="primary"
                   @click="addUpdate()">{{ $t('add') }}</el-button>
        <el-button plain
                   class="el-button-columnBtn"
                   @click="exportHandle()">{{ $t('export') }}</el-button>
      </div>
      <el-table v-loading="dataListLoading"
                :data="dataList"
                border
                style="width: 100%">
        <!-- 角色名称 -->
        <el-table-column prop="roleName"
                         :label="$t('role.roleName')"
                         header-align="center"
                         align="left"
                         width="160"
                         show-overflow-tooltip></el-table-column>
        <!-- 角色编码 -->
        <el-table-column prop="roleCode"
                         :label="$t('role.roleCode')"
                         header-align="center"
                         width="110"
                         align="left"
                         show-overflow-tooltip></el-table-column>
        <!-- 组织类型 -->
        <el-table-column prop="orgType"
                         :label="$t('organization.orgType')"
                         header-align="center"
                         :formatter="orgTypeFormatter"
                         align="center"
                         show-overflow-tooltip></el-table-column>
        <!-- 权限分类 -->
        <el-table-column prop="authType"
                         :label="$t('user.permissionclassification')"
                         header-align="center"
                         :formatter="authTypeFormatter"
                         align="center"
                         show-overflow-tooltip></el-table-column>
        <!-- 角色分类 -->
        <el-table-column prop="roleType"
                         :label="$t('role.authType')"
                         header-align="center"
                         :formatter="roleTypeFormatter"
                         align="center"
                         show-overflow-tooltip></el-table-column>
        <!-- 数据范围分类 -->
        <el-table-column prop="roleOrgScope"
                         :label="$t('role.roleOrgScope')"
                         header-align="center"
                         width="200"
                         :formatter="roleOrgScopeFormatter"
                         align="left"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="defaultFlag"
                         width="120"
                         :label="$t('role.defaultFlag')"
                         header-align="center"
                         :formatter="defaultFlagFormatter"
                         align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="createUserName"
                         :label="$t('role.createUser')"
                         header-align="center"
                         align="left"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime"
                         :label="$t('role.createTime')"
                         header-align="center"
                         width="150"
                         align="center"
                         show-overflow-tooltip></el-table-column>
        <!-- 操作 -->
        <el-table-column fixed="right"
                         :label="$t('user.operation')"
                         width="120"
                         align="center">
          <template slot-scope="scope">
            <!-- 查看 -->
            <span class="el-dropdown-link"
                  @click="gotoView(scope.row.roleId)">{{ $t('view') }}</span>
            <el-divider direction="vertical"></el-divider>
            <el-dropdown trigger="click"
                         placement="bottom">

              <span class="el-dropdown-link">
                {{ $t('user.operation') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item @click.native="gotoView(scope.row.roleId)">{{ $t('view') }}</el-dropdown-item> -->
                <el-dropdown-item @click.native="gotoUpdate(scope.row.roleId)">{{ $t('update') }}</el-dropdown-item>
                <el-dropdown-item @click.native="distributionUser(scope.row)">{{ $t('role.distributionUser') }}</el-dropdown-item>
                <!-- <el-dropdown-item @click.native="deleteRole(scope.row.roleId)">{{ $t('delete') }}</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <role-user v-if="roleUserVisible"
                 ref="roleUser"
                 @refreshDataList="getDataList"></role-user>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import ToggleDiv from '@/components/toggle-div'
import RoleUser from './role-user'
import Vue from 'vue'

export default {
  mixins: [mixinViewModule],
  data() {
    let _this = this
    return {
      // 共通的接口Option
      mixinViewModuleOptions: {
        getDataListURL: '/sys/role/list',
        getDataListIsPage: true,
        deleteURL: '/sys/role/delete',
        deleteIsBatch: true
      },
      dataForm: {
        // 角色名称
        roleName: '',
        // 角色分类
        roleType: '',
        // 组织类型
        orgType: '',
        // 权限分类
        authType: '',
        // 角色范围属性
        roleOrgScope: '',
        // 是否内置岗位
        defaultFlag: ''
      },
      // 数据范围分类 根据角色分类进行判断
      roleOrgScope: [],
      // 权限分类
      perClassification: _this.enums['perClassification'],
      perClassificationMerga: [],
      authTypeArr: [],
      // 组织类型
      orgTypeArr: _this.enums['orgType'],
      roleOrgType: [],
      // 角色分类
      roleType: _this.enums['authType'],
      // 是否
      confirmStateArr: this.enums['defaultFlag'],
      // 是否显示分配用户
      roleUserVisible: false,
      isShow: false
    }
  },
  components: {
    RoleUser,
    ToggleDiv
  },
  mounted() {
    this.roleOrgType = JSON.parse(JSON.stringify(this.orgTypeArr))
    if (this.roleOrgType.length === 6) {
      this.roleOrgType.splice(4, 1)
    }
    this.perClassificationMerga = JSON.parse(JSON.stringify(this.perClassification))
    for (let index in this.perClassificationMerga) {
      if (this.perClassificationMerga[index].code + '' === '50') {
        this.perClassificationMerga.splice(index, 1)
      }
    }
  },
  methods: {
    roleTypeChange() {
      this.dataForm.roleOrgScope = ''
      if (this.dataForm.roleType === '10') {
        this.roleOrgScope = this.enums['roleOrgScope']
      } else if (this.dataForm.roleType === '20') {
        this.roleOrgScope = this.enums['ProcedureRoleScope']
      } else {
        this.roleOrgScope = []
      }
    },
    // 重置
    resetModify() {
      this.page = 1
      this.dataForm = {
        // 角色名称
        roleName: '',
        // 角色分类
        roleType: '',
        // 组织类型
        orgType: '',
        // 权限分类
        authType: '',
        // 角色范围属性
        roleOrgScope: '',
        // 是否内置岗位
        defaultFlag: ''
      }
      this.roleOrgScope = []
      this.getDataList()
    },
    orgTypeChange() {
      this.dataForm.authType = ''
      if (this.dataForm.orgType === '30') {
        this.authTypeArr = JSON.parse(JSON.stringify(this.perClassification))
      } else {
        this.authTypeArr = JSON.parse(JSON.stringify(this.perClassificationMerga))
      }
    },
    /**
     * 跳转查看页面
     * @param roleId 当前行角色ID
     */
    gotoView(roleId) {
      // 广播通知需要清空表单
      this.$router.push({
        name: 'sys-role-view',
        query: {
          roleId: roleId
        }
      })
    },
    /**
     * 跳转修改页面
     * @param roleId 当前行角色ID
     */
    gotoUpdate(roleId) {
      // 广播通知需要清空表单
      this.$router.push({
        name: 'sys-role-add-or-update',
        query: {
          roleId: roleId
        }
      })
      this.$eventHub.$emit(this.GLOBAL.ACTIVATED_ROLE, 'activated')
    },
    /**
     * 分配用户
     * @param roleId 当前行角色ID
     */
    distributionUser(row) {
      this.roleUserVisible = true
      this.$nextTick(() => {
        this.$refs.roleUser.authType = row.authType
        this.$refs.roleUser.orgType = row.orgType
        this.$refs.roleUser.roleId = row.roleId
        this.$refs.roleUser.roleType = row.roleType
        // this.$refs.roleUser.dataForm.id = row.id
        // this.$refs.roleUser.dataForm.pid = this.dataForm.pid
        // this.$refs.roleUser.dataForm.dictType = row.dictType || this.dataForm.dictType || ''
        this.$refs.roleUser.init()
      })
    },
    /**
     * 改变权限分类
     */
    // authType 10:Admin 20：普通用户 30：老师 40：管理层
    // orgType 10：合作伙伴 20：合作院校 30：BMW Group 40：Outlet
    changeAuthType: function (val) {

    },
    // 新增
    addUpdate() {
      // 广播通知需要清空表单
      this.$router.push({
        name: 'sys-role-add-or-update'
      })
      this.$eventHub.$emit(this.GLOBAL.ACTIVATED_ROLE, 'activated')
    },
    // 删除角色
    // deleteRole (roleId) {
    //   this.$confirm(this.$t('prompt.role'), this.$t('prompt.title'), {
    //     confirmButtonText: this.$t('confirm'),
    //     cancelButtonText: this.$t('cancel')
    //   }).then(() => {
    //     this.$request.delete(
    //       this.mixinViewModuleOptions.deleteURL,
    //       {
    //         roleId: roleId
    //       }
    //     ).then((res) => {
    //       this.$message({
    //         message: this.$t('prompt.success'),
    //         type: 'success',
    //         duration: 500,
    //         onClose: () => {
    //           this.getDataList()
    //         }
    //       })
    //     }).catch(() => { })
    //   }).catch(() => { })
    // },
    orgTypeFormatter(row) {
      if (row.roleType === '10') {
        return Vue.filter('coverEnum')(row.orgType, 'orgType')
      } else {
        return ''
      }
    },
    // 权限
    authTypeFormatter(row) {
      if (row.roleType === '10') {
        return Vue.filter('coverEnum')(row.authType, 'perClassification')
      } else {
        return ''
      }
    },
    // 角色
    roleTypeFormatter(row) {
      return Vue.filter('coverEnum')(row.roleType, 'authType')
    },
    // 数据范围
    roleOrgScopeFormatter(row) {
      if (row.roleType === '10') {
        return Vue.filter('coverEnum')(row.roleOrgScope, 'roleOrgScope')
      } else {
        return Vue.filter('coverEnum')(row.roleOrgScope, 'ProcedureRoleScope')
      }
    },
    defaultFlagFormatter(row) {
      return Vue.filter('coverEnum')(row.defaultFlag, 'defaultFlag')
    },
    // 展开更多
    toggle(data) {
      this.isShow = data
    },
    // 导出
    exportHandle() {
      this.page = 1
      // download 参数 url, params, 报表名
      this.$request.download('/sys/role/export', this.$t('role.organizationExport'),
        {
          ...this.dataForm,
          page: this.page,
          limit: 5000
        }
      )
    }
  }
}
</script>
<style lang='scss' scoped>
.tableleft {
  padding-left: 1% !important;
}
.tablelabel {
  padding-left: 0 !important;
}
</style>
